// extracted by mini-css-extract-plugin
export default {"content":"menuCategoryListContainer_content__6Cve3","newMenuCategoryButton":"menuCategoryListContainer_newMenuCategoryButton__CIwBg"};